import React from "react";
import classes from "./ServiceAppForm.module.css"

import Button from "../../../UI/Button/Button";

const ServiceAppForm = props =>{

    return <div className={classes.container}>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>الخدمة:</div>
        <div className={classes.value}>{props.Service.ServDesc}</div>
      </span>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>الإسم:</div>
        <input className={classes.textField} />
      </span>
      <span className={classes.row} dir="rtl">
        <div className={classes.label}>رقم الهاتف:</div>
        <input type="tel" className={classes.textField} />
      </span>

      <h4>سيتم التواصل معكم لتحديد الموعد</h4>

      <div className={classes.actions}>
        <Button className={classes.button}>Submit</Button>
      </div>
    </div>
}
export default ServiceAppForm